
import { Options, Vue } from "vue-class-component";
import AlbumFilterAndDisplayComponent from "@/components/ui/BaseAlbumFilterAndDisplayComponent/index.vue";

@Options({
  name: "HomeComponentAssetFilterAndDisplay",
  components: { AlbumFilterAndDisplayComponent },
})
export default class HomeComponentAssetFilterAndDisplay extends Vue {}
